import styled from '@emotion/styled'
import { useState } from 'react'

import Star from '../../icons/Star'
import { Color, color, getColor, theme } from '../../Theme'
import { MaybeColor } from '../../types'

const Row = styled.div`
  ${theme.layout.flexRow};
  ${theme.spacing.ends('small')};
  background: ${(p) => getColor(p.theme, ['white'], ['nightHighlight'])};
  box-sizing: border-box;
  flex: 2;
  justify-content: center;
  text-align: center;
`

const RatingButton = styled.button<{ starColor: MaybeColor }>`
  ${theme.layout.flexRow};
  ${theme.spacing.all('small')};
  ${theme.text('largest', 'content', 'bold')};
  background: none;
  border: none;
  box-sizing: border-box;
  color: ${(p) => color(p.starColor)};
  cursor: pointer;
  justify-content: center;
  width: ${theme.spacing.sizes.huge};
  text-align: center;
`

type Props = {
  stars: number
  onChange: (stars: number) => void
}

const RatingButtons = ({ stars, onChange }: Props) => {
  const [hoverStars, setHoverStars] = useState(0)
  const shownStars = hoverStars || stars

  return (
    <Row onMouseLeave={() => setHoverStars(0)}>
      {[1, 2, 3, 4].map((value) => (
        <RatingButton
          key={value}
          type="button"
          aria-label={String(value)}
          aria-pressed={value === stars}
          starColor={shownStars >= value ? (`star${value}` as Color) : 'grayDark'}
          onClick={() => onChange(value)}
          onMouseEnter={() => setHoverStars(value)}
        >
          <Star iconSize="normal" />
        </RatingButton>
      ))}
    </Row>
  )
}

export default RatingButtons
